import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { ROUTES_TITLES } from '@app/core/navigation/route-titles';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({ providedIn: 'root' })
export class CustomTitleStrategy extends TitleStrategy {
  private readonly titleService: Title = inject(Title);
  private readonly translateService: TranslocoService = inject(TranslocoService);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const currentUrl = snapshot.url.split('?')[0];
    let titleKey: string | undefined = undefined;
    const sortedMappings = [...ROUTES_TITLES].sort((a, b) => b.url.length - a.url.length);
    for (const mapping of sortedMappings) {
      if (currentUrl.startsWith(mapping.url)) {
        titleKey = mapping.title;
        break;
      }
    }

    if (!titleKey) {
      titleKey = this.buildTitle(snapshot);
    }

    if (titleKey) {
      const translatedTitle = this.translateService.translate(titleKey);
      this.titleService.setTitle(`${translatedTitle}`);
    } else {
      this.titleService.setTitle('elxa | Lync');
    }
  }
}
